import { render, staticRenderFns } from "./EditTextureStyle.vue?vue&type=template&id=40965ead&"
import script from "./EditTextureStyle.vue?vue&type=script&lang=js&"
export * from "./EditTextureStyle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports